import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { AuthServiceService } from '../services/auth-service.service';
import { IUserProfile} from '../interfaces/IUserProfile.interface'
import { UserProfile} from '../models/UserProfile';
import { PwrDetails} from '../models/PwrDetails';


@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css']
})
export class AccountComponent implements OnInit {

	isAuthenticated: boolean = false;
	userName: string = "";
	userProfile: IUserProfile;
	showReset: boolean = false;
	details: PwrDetails = new PwrDetails();
	successful: boolean = false;
	failed: boolean = false;
	message: string = '';

	constructor(private authService: AuthServiceService, private router: Router) { }

	ngOnInit() {
		if(sessionStorage.getItem("referred") && (sessionStorage.getItem("referred") == 'login' || sessionStorage.getItem("referred") == 'new-account'))
		{ 
			sessionStorage.setItem("referred", '');
			location.reload();
		}
		else {
			if(sessionStorage.getItem("token")){
		        let obj = JSON.parse(sessionStorage.getItem("token"));
		        let test;
		        if(obj && obj.Token != ""){
		            this.isAuthenticated = true;
		            this.userName = obj.userName;
		            this.authService.getUserProfile(obj.profileId).subscribe(
		            	profile => {
		            		this.userProfile = profile;
	            	});            
		        }
		    }
			else {
			  	this.router.navigate(['/login']);
			}
		}
	}

	toggleReset(){
		this.showReset = !this.showReset;
	}

	SaveAccountChanges(){
		this.authService.UpdateProfile(this.userProfile).subscribe(
			resp => {
				if(resp == "Email address exists for another account."){
					this.message = resp;
				}
				else {
					this.message = "Successfully saved account changes.";
					this.userProfile = resp;
				}
			}, error => {this.message = "An error occurred.";});
	}

	changePassword(){
		this.details.profileId = this.userProfile.Id;
		this.authService.ResetPasswordFromAccount(this.details).subscribe(
			resp => {
				if(resp == "Reset completed Successfully."){
		          this.successful = true;
		        }
		        else 
		          this.failed = true;
		      }, error => {this.failed = true;});
	}
}



// WEBPACK FOOTER //
// ./src/app/account/account.component.ts